import { LeaderboardPlayer } from '../leaderboard.types';

export const API_URL = import.meta.env.VITE_RPS_API + '/leaderboard';

export interface ILeaderboardResponse {
  columns: string[];
  rows: LeaderboardPlayer[];
}

export async function fetchLeaderboard(signal?: AbortSignal): Promise<ILeaderboardResponse> {
  const res = await fetch(API_URL, { signal });
  if (!res.ok) throw new Error(`Failed to fetch leaderboard: ${res.status}`);
  let data = await res.json();
  return data;
}
